$(document).ready(function() {
    // WISHLIST
    var wishlist_storage = JSON.parse(localStorage.getItem("wishlist"));
      if (wishlist_storage === null) {
        wishlist_storage = [];
        localStorage.setItem("wishlist", JSON.stringify(wishlist_storage));
      }
    
      var s_currency = $("#wislist__page").data("currency");
      $(".wish-list .wish-list-icon").on("click", function () {
        $(this).toggleClass("active");
        var data = $(this).data("handle");
        var storage = JSON.parse(localStorage.getItem("wishlist"));
        storage.indexOf(data) === -1
          ? storage.push(data)
          : storage.splice(storage.indexOf(data), 1);
        localStorage.setItem("wishlist", JSON.stringify(storage));
        var get_for_count = JSON.parse(localStorage.getItem("wishlist"));
        
        if (get_for_count.length == 0) {
          $(".header .header__icon").removeClass('active');
        } else {
          $(".header .header__icon").addClass('active');
        }
        
      });
    
      var get_wish_list = JSON.parse(localStorage.getItem("wishlist"));
    
      wishlist_icon();
      function wishlist_icon() {
        var wishlist_i = JSON.parse(localStorage.getItem("wishlist"));
        for (var i = 0; i < wishlist_i.length; i++) {
          $(".wish-list-icon").each(function (k) {
            if ($(this).data("handle") == wishlist_i[i]) {
              $(this).addClass("active");
            }
          });
        }
      }
    
      if ($("#wislist__page").length) {
        for (var i = 0; i < get_wish_list.length; i++) {
          jQuery.getJSON(
            "/products/" + get_wish_list[i] + ".js",
              function (product) {
                $(".wishlist-container .wishlist-content").append(
                  '<div class="wishlist-item"><div class="w-product-image"><a href="' +
                    product.url +
                    '"><img src="' +
                    product.featured_image +
                    '"></a></div>' +
                    '<div class="w-product-t_v"><a class="w-product-title" href="' +
                    product.url +
                    '">' +
                    product.title +
                    '</a></div>' +
                  
                    '<div class="text-center w-product-price"><span>' +
                    s_currency +
                    (product.price / 100).toFixed(2) +
                    "</span></div>" +
                  
                    "<div class='w-product-cart quick-add no-js-hidden' data-remove='" +
                      product.handle +
                    "'><product-form> <form method='post' action='/cart/add' accept-charset='UTF-8' class='form' enctype='multipart/form-data' novalidate='novalidate' data-type='add-to-cart-form'><input type='hidden' name='form_type' value='product'><input type='hidden' name='utf8' value='✓'> <input type='hidden' name='id' value='"+
                    product.variants[0].id +
                    "' class="+
                    '"product-variant-id"><button type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog" aria-live="polite" data-sold-out-message="true"><span>Add To Cart</span><div class="loading__spinner hidden"><svg aria-hidden="true"focusable="false"class="spinner"viewBox="0 0 66 66"xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></button></form></product-form></div>'+
                    '<div class="text-center w-product-del"><a class="w-product-remove" href="javascript:void(0)" data-remove="' +
                    product.handle +
                    '"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24"><path d="M 10.806641 2 C 10.289641 2 9.7956875 2.2043125 9.4296875 2.5703125 L 9 3 L 4 3 A 1.0001 1.0001 0 1 0 4 5 L 20 5 A 1.0001 1.0001 0 1 0 20 3 L 15 3 L 14.570312 2.5703125 C 14.205312 2.2043125 13.710359 2 13.193359 2 L 10.806641 2 z M 4.3652344 7 L 5.8925781 20.263672 C 6.0245781 21.253672 6.877 22 7.875 22 L 16.123047 22 C 17.121047 22 17.974422 21.254859 18.107422 20.255859 L 19.634766 7 L 4.3652344 7 z"></path></svg>' +
                    "</div>"
                );
              }
            );
          }
        }
    
        if (get_wish_list.length == 0) {
          $(".wishlist-container").hide();
          $(".wishlist-empty-wrap").show();
          $(".header .header__icon").removeClass('active');
        } else {
          $(".wishlist-container").show();
          $(".wishlist-empty-wrap").hide();
          $(".header .header__icon").addClass('active');
        }

        $(document).on('click','.w-product-remove',function(){
          var removeitem = JSON.parse(localStorage.getItem("wishlist"));
          removeitem.splice(removeitem.indexOf($(this).data("remove")), 1);
          localStorage.setItem("wishlist", JSON.stringify(removeitem));
          $(this).parents(".wishlist-item").remove();
          if (removeitem.length == 0) {
            $(".wishlist-container").hide();
            $(".wishlist-empty-wrap").show();
            $(".header .header__icon").removeClass('active');
          }else{
            $(".header .header__icon").addClass('active');
          }

      });

    $(document).on('click','.w-product-cart.quick-add',function(){
          var removeitem = JSON.parse(localStorage.getItem("wishlist"));
          removeitem.splice(removeitem.indexOf($(this).data("remove")), 1);
          localStorage.setItem("wishlist", JSON.stringify(removeitem));

    });

  // PRODUCT STICKY ADD TO CART

  if($("product-recommendations").length != 0){
    setInterval(function () {
      $("product-recommendations ul li.grid__item").each(function(){
        var AHref = $(this).find("a").attr("href").split("?")[0];
        $(this).find("a").attr("href", AHref);
      });
    }, 500);
  }
  
  if($('.product-sticky-cart').length){
    $(window).scroll(function(){
      var btn_pos = $('.main-product-section product-info product-form').offset().top;
      var footer_pos_top = $('footer').offset().top;
      var footer_pos_btm = footer_pos_top + $('footer').outerHeight();
      var viewporttop = $(this).scrollTop();
      var viewportbottom = $(window).height() + $(this).scrollTop();
      if (viewporttop > btn_pos && viewportbottom < footer_pos_top){
        $('.product-sticky-cart').fadeIn(500);
      }else{
        $('.product-sticky-cart').fadeOut(500);
      }
    });
  }
  
}); 

// Enquiry Button on Product Grid

// document.querySelectorAll(".unique-identifier").forEach(function (element) {
//     let newDiv = document.createElement("div");
//     newDiv.className = "pro_conatct";
//     newDiv.innerHTML = '<button class="button hs-cta-trigger-button hs-cta-trigger-button-187533614420">Get A Quote</button>';
    
//     element.insertAdjacentElement("afterend", newDiv);
// });

// PDF Popup


$(document).ready(function() {
  setTimeout(function(){
    setInterval(() => {
        let successMessage = document.querySelector("body.template-wholesale .waio--success-message");
        if (successMessage) {
            window.location.href = "/pages/wholesale-thank-you";
        }
    }, 1000);
    
      setInterval(() => {
        let formFrame = document.querySelector("body.template-contact .hs-form-frame");
          if (formFrame) {
              let height = parseInt(window.getComputedStyle(formFrame).height);
              if (height < 400) {
                  window.location.href = "/pages/contact-thank-you";
            }
        }
      }, 1000);
  }, 5000)
})
